/**
 * URL parameter utilities
 */

export interface RaceConfig {
    id: string;
    name: string;
    csvFile: string;
}

export const RACES: Record<string, RaceConfig> = {
    '9': {
        id: '9',
        name: '#9Greece',
        csvFile: 'data/race_results_9.csv'
    },
    '10': {
        id: '10',
        name: '#10Montenegro',
        csvFile: 'data/race_results_10.csv'
    }
};

export const DEFAULT_RACE = '9';

/**
 * Gets the race ID from URL parameters
 */
export function getRaceId(): string {
    const urlParams = new URLSearchParams(window.location.search);
    const raceParam = urlParams.get('race');

    // Validate race parameter
    if (raceParam && RACES[raceParam]) {
        return raceParam;
    }

    return DEFAULT_RACE;
}

/**
 * Gets the race configuration
 */
export function getRaceConfig(): RaceConfig {
    const raceId = getRaceId();
    return RACES[raceId] || RACES[DEFAULT_RACE];
}
